// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1q-q";
export var animationRelative = "_1q-p";
export var backdropBlur = "_1q-0";
export var detailLabelCell = "_1q-12";
export var detailTable = "_1q-11";
export var detailValueCell = "_1q-13";
export var docIconBox = "_1q-1d";
export var docIconBoxMd = "_1q-1f";
export var docIconBoxSm = "_1q-1e";
export var docTypeRow = "_1q-16";
export var docTypeRowInner = "_1q-17";
export var dropdownMatchDatePicker = "_1q-3";
export var evidenceCardContent = "_1q-1c";
export var fileUploadSpin = "_1q-j";
export var gorgiasOpenButton = "_1q-15 _1q-d";
export var gorgiasTicketCard = "_1q-14";
export var heroModalFooterButton = "_1q-18";
export var hiddenContainer = "_1q-o";
export var iconPrimary = "_1q-1g";
export var iconSecondary = "_1q-1h";
export var iconTertiary = "_1q-1i";
export var integrationCard = "_1q-1";
export var integrationLogoBox = "_1q-2";
export var mainColumnSticky = "_1q-1b";
export var maxWidthContainer = "_1q-19";
export var modalContentBody = "_1q-a";
export var modalHeaderImage = "_1q-5";
export var modalImageLabel = "_1q-7";
export var modalImageOverlay = "_1q-6";
export var modalImageSubtitle = "_1q-9";
export var modalImageTitle = "_1q-8";
export var modalImageWrapper = "_1q-4";
export var modalStickyFooter = "_1q-b";
export var removeButton = "_1q-e";
export var sidebarColumn = "_1q-1a";
export var spinner = "_1q-i";
export var timelineLine = "_1q-y";
export var timelineLineBlack = "_1q-10 _1q-y";
export var timelineLineGray = "_1q-z _1q-y";
export var timelineLineHeight = "_1q-x";
export var tlDotActivate = "_1q-u";
export var tlDotActivateAnim = "_1q-t";
export var tlDotHide = "_1q-s";
export var tlDotHideAnim = "_1q-r";
export var tlLineActivate = "_1q-w";
export var tlLineActivateAnim = "_1q-v";
export var uploadHint = "_1q-n";
export var uploadIconBox = "_1q-k";
export var uploadLabel = "_1q-m";
export var uploadText = "_1q-l";
export var uploadZone = "_1q-f";
export var uploadZoneCursorDefault = "_1q-h";
export var uploadZoneCursorPointer = "_1q-g";
export var uploadedFileRow = "_1q-c";
export var viewButton = "_1q-d";